import { BaseWebComponentRepository } from '../framework/BaseWebComponentRepository';
import { BaseWidgetDataProviderFactory } from './BaseWidgetDataProviderFactory';
import { BaseWidgetDataProvider } from './BaseWidgetDataProvider';
import { GetWidgetDataRequest } from '../types/widget/types';
import { RequestOptions } from '@nirvana/shared/websocket-client';
import { Observable } from 'rxjs';
import { ReportingPeriod } from '@nirvana/shared/dtos/types/shared/time';

export class BaseWidgetRepository<T> extends BaseWebComponentRepository {
  public dataProviderFactory: BaseWidgetDataProviderFactory<T>;
  public dataProvider: BaseWidgetDataProvider<T>;

  constructor(dataFetchMethod: (request: GetWidgetDataRequest, options: RequestOptions) => Observable<T>) {
    super();
    this.initialSetup({
      dataProviderFactory: new BaseWidgetDataProviderFactory(dataFetchMethod),
    });
  }

  async readValue(params: {
    reportingPeriod: ReportingPeriod;
    widgetId: string;
    dashboardId: string;
    locale: string;
    timezone: string;
    targetIds: Array<string>;
  }): Promise<T | undefined> {
    return await this.dataProvider.getValues(params);
  }
}
